import { BASE_ENDPOINT } from '../endpoints'

const main = `${BASE_ENDPOINT}/auth/`
export const login = `${main}login`
export const verifyCode = `${main}verify-code`
export const logout = `${main}logout`
export const allPricesPackages =  `${main}getAllPrices`
export const accountRFCInfo = `${main}account-rfc-info`
export const fielSingUp = `${main}setup-fiel`
export const emailPayment = `${main}email-payment`
export const resetPassowrdUrl = `${main}reset-password`
export const setPassowrdUrl = `${main}set-password`
export const sendMailValidate = `${main}validate-information`
export const sendMailValidatePymesUrl = `${main}validate-information-pymes`
export const decodeTokenInfoUser = `${main}decode-personal-information`
export const activateEmailUser = `${main}activateEmail`
export const updateAllInfoUser = `${main}updateInfoUser`
export const accountSignupUrl = `${BASE_ENDPOINT}/api/v1/create-checkout-session`
export const accountMeUrl = `${BASE_ENDPOINT}/api/v1/me`
export const customerConekta = `${BASE_ENDPOINT}/api/v1/accounts/conekta`
export const customerConektaPymes = `${BASE_ENDPOINT}/api/v1/accounts/conekta-pymes`
export const zohoDataSend = `${BASE_ENDPOINT}/api/v1/accounts/zoho`
export const zohoPymesDataSend = `${BASE_ENDPOINT}/api/v1/accounts/zoho/pymes`
export const getAccountsZoho = `${BASE_ENDPOINT}/zoho/accounts`
export const validateNotExistUser = `${BASE_ENDPOINT}/api/v1/accounts/validate`
export const validateFIELExist = `${BASE_ENDPOINT}/api/v1/accounts/validate-fiel-exist`
export const validateNotExistUserRFC = `${BASE_ENDPOINT}/api/v1/accounts/validate-rfc`
export const signupUser = `${BASE_ENDPOINT}/api/v1/accounts/signup`
export const orderConekta = `${BASE_ENDPOINT}/api/v1/accounts/conekta/order`
export const validateEmailUrl = `${BASE_ENDPOINT}/validate-email`
export const validateCouponUrl = `${BASE_ENDPOINT}/api/v1/accounts/subscriptions/validate-coupon`
export const validateUserFielUrl = `${BASE_ENDPOINT}/api/v1/account-rfc/setup-fiel/validate`
export const automaticBillingUrl = `${BASE_ENDPOINT}/automatic-billing`
export const getCFDIUseByFiscalRegimeUrl = `${BASE_ENDPOINT}/get-cfdi-use-fiscal-regime`
export const confirmationRFCCompanyNameURL = `${BASE_ENDPOINT}/api/v1/accounts/lrfc/validate`
export const getTokenInfo = `${BASE_ENDPOINT}/user/renew`
export const sendNewPaymentReference = `${BASE_ENDPOINT}/user/reference`
export const newPaymentUser = `${BASE_ENDPOINT}/user/new-activation`
export const getNewConektaUserOrder = `${BASE_ENDPOINT}/user/conekta-order`
export const getNewConektaBusinessOrder = `${BASE_ENDPOINT}/user/conekta-business`
export const tokenPayment = `${BASE_ENDPOINT}/api/v1/accounts/token-payment`
export const checkRecaptchaGoogle = `${BASE_ENDPOINT}/api/v1/accounts/verify-captcha`
export const tokenBusinessPayment = `${BASE_ENDPOINT}/api/v1/accounts/business-payment-token`
export const activateBusinessSubscriptionUrl = `${BASE_ENDPOINT}/api/v1/accounts/activate-subscription`
export const allMyAccountCFDICount = `${BASE_ENDPOINT}/api/v1/accounts/my-account/cfdis-counter`
export const getMyCurrentSubscription = `${BASE_ENDPOINT}/api/v1/accounts/my-account/currentSub`;
export const enableTwoFactorAuth = `${main}activate-2fa`;
export const logbookEntry = `${main}logbook/entry`;
